/* eslint-disable consistent-return */
import { useEffect, useState } from 'react';
import ToastWrapper from './ToastWrapper.jsx';
import ToastIcon from './ToastIcon.jsx';
import DismissButton from './DismissButton.jsx';
import ActionText from './ActionText.jsx';
import { useToastContext } from './ToastContext.jsx';
import useTimeout from '../../hooks/useTimeout.js';

export default function Toaster() {
  const { toasts, removeToast } = useToastContext();

  return (
    <>
      {toasts.map((toast, index) => (
        <Toast
          key={toast.id}
          {...toast}
          removeToast={removeToast}
          index={index}
        />
      ))}
    </>
  );
}

export function Toast({
  id,
  toastMessage,
  inline,
  position,
  align,
  variant,
  actionText,
  dismissible,
  light,
  timeout = 5000,
  removeToast,
  actionCallback,
  index,
  autoDismiss,
  iconAltText,
  dismissLabel,
}) {
  const { clearAllToasts } = useToastContext();
  const [isLeaving, setIsLeaving] = useState(false);
  useTimeout(() => {
  // for accessibility, we want to disable auto-dismiss if
  // there is an action button on the toast
    if (autoDismiss && !actionText.length) {
      dismissToast();
    }
  }, timeout);
  function dismissToast() {
    setIsLeaving(true);
    removeToast(id);
  }
  useEffect(() => {
    if (clearAllToasts) {
      dismissToast();
    }
  }, [clearAllToasts]);

  return (
    <>
      <ToastWrapper
        id={id}
        inline={inline}
        position={position}
        align={align}
        light={light}
        isLeaving={isLeaving}
        index={index}
        variant={variant}
      >
        <ToastIcon altText={iconAltText} variant={variant} />

        <div className="lds-toast-content">{toastMessage}</div>

        <ActionText
          actionText={actionText}
          actionCallback={actionCallback}
          dismissible={dismissible}
        />
        {dismissible && (
          <DismissButton
            id={id}
            dismissLabel={dismissLabel}
            dismissCallback={dismissToast}
          />
        )}
      </ToastWrapper>
    </>
  );
}
